import React from 'react'

const LoadingDotsIcons = () => {
  return (
    <div className="dots-loading">
      <div></div>
    </div>
  )
}

export default LoadingDotsIcons
